export enum ObstructionType {
	Standard = 'WALL',
	Pillar = 'PILLAR',
	Column = 'COLUMN',
	Railing = 'RAILING',
	Misc = 'MISC'
}
